import { httpsCallable } from 'firebase/functions';
import { auth, functions } from './firebase';

const ALLOWED_RETURN_HOSTS = [
  'tempo.radley.pro',
  'labs.radley.pro',
  'radley.pro',
  'www.radley.pro',
  'localhost',
  '127.0.0.1',
];

export interface ParsedReturn {
  target: URL;
  next: string;
}

export function parseReturnTo(raw: string | null): ParsedReturn | null {
  if (!raw) return null;
  let url: URL;
  try {
    url = new URL(raw);
  } catch {
    return null;
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
  if (!ALLOWED_RETURN_HOSTS.includes(url.hostname)) return null;

  const next = `${url.pathname}${url.search}${url.hash}` || '/';
  return { target: url, next };
}

export function defaultReturnTo(brand: string | null): ParsedReturn {
  const fallback =
    brand === 'labs'
      ? new URL('https://labs.radley.pro/')
      : new URL('https://tempo.radley.pro/launchpad');
  return { target: fallback, next: `${fallback.pathname}${fallback.search}` || '/' };
}

export async function redirectWithHandoff(ret: ParsedReturn): Promise<void> {
  const user = auth.currentUser;
  if (!user) {
    window.location.replace(ret.target.toString());
    return;
  }

  let handoffToken: string | null = null;
  try {
    const callable = httpsCallable<{ returnOrigin: string }, { token: string }>(
      functions,
      'mintAuthHandoffToken',
    );
    const result = await callable({ returnOrigin: ret.target.origin });
    handoffToken = result.data?.token ?? null;
  } catch (error) {
    console.error('Failed to mint handoff token', error);
  }

  const callbackUrl = new URL('/auth-callback', ret.target.origin);
  if (handoffToken) callbackUrl.searchParams.set('token', handoffToken);
  callbackUrl.searchParams.set('next', ret.next);
  window.location.replace(callbackUrl.toString());
}
